package com.iregained.eventapp.utils

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint

object Res {
    private const val BASE = "/images"

    object Strings {
        const val APP_NAME = "Hand Rehab Event Portal"

        object PatientStatus {
            const val BOOKED = "BOOKED"
            const val CHECKED_IN = "CHECKED_IN"
            const val PRE_COMPLETE = "PRE_COMPLETE"
            const val TRIAL_COMPLETE = "TRIAL_COMPLETE"
            const val POST_COMPLETE = "POST_COMPLETE"
            const val FEEDBACK_COMPLETE = "FEEDBACK_COMPLETE"
        }

        object Buttons {
            const val EXPORT_PDF = "Export Clinical Report"
            const val CANCEL = "Cancel"
            const val SUBMIT = "Submit"
        }
    }

    object IRColors {
        // Backgrounds & Surfaces
        val Background = Color.rgb(0xf7fafa)
        val OnBackground = Color.rgb(0x181c1d)
        val Surface = Color.rgb(0xf7fafa)
        val SurfaceDim = Color.rgb(0xd7dbdb)
        val SurfaceBright = Color.rgb(0xf7fafa)
        val SurfaceVariant = Color.rgb(0xe0e3e3)
        val SurfaceContainerLowest = Color.rgb(0xffffff)
        val SurfaceContainerLow = Color.rgb(0xf1f4f4)
        val SurfaceContainer = Color.rgb(0xebeeee)
        val SurfaceContainerHigh = Color.rgb(0xe6e9e9)
        val SurfaceContainerHighest = Color.rgb(0xe0e3e3)
        val OnSurface = Color.rgb(0x181c1d)
        val OnSurfaceVariant = Color.rgb(0x3e4949)
        val InverseSurface = Color.rgb(0x2d3131)
        val InverseOnSurface = Color.rgb(0xeef1f1)
        val SurfaceTint = Color.rgb(0x006a6a)

        // Outlines
        val Outline = Color.rgb(0x6e7979)
        val OutlineVariant = Color.rgb(0xbdc9c8)

        // Primary Colors
        val Primary = Color.rgb(0x006565)
        val OnPrimary = Color.rgb(0xffffff)
        val PrimaryContainer = Color.rgb(0x008080)
        val OnPrimaryContainer = Color.rgb(0xe3fffe)
        val InversePrimary = Color.rgb(0x76d6d5)
        val PrimaryFixed = Color.rgb(0x93f2f2)
        val PrimaryFixedDim = Color.rgb(0x76d6d5)
        val OnPrimaryFixed = Color.rgb(0x002020)
        val OnPrimaryFixedVariant = Color.rgb(0x004f4f)

        // Secondary Colors
        val Secondary = Color.rgb(0x0d6969)
        val OnSecondary = Color.rgb(0xffffff)
        val SecondaryContainer = Color.rgb(0xa3f0ef)
        val OnSecondaryContainer = Color.rgb(0x196f70)
        val SecondaryFixed = Color.rgb(0xa3f0ef)
        val SecondaryFixedDim = Color.rgb(0x87d3d3)
        val OnSecondaryFixed = Color.rgb(0x002020)
        val OnSecondaryFixedVariant = Color.rgb(0x004f50)

        // Tertiary Colors
        val Tertiary = Color.rgb(0x246363)
        val OnTertiary = Color.rgb(0xffffff)
        val TertiaryContainer = Color.rgb(0x3f7c7c)
        val OnTertiaryContainer = Color.rgb(0xe2fffe)
        val TertiaryFixed = Color.rgb(0xb0eeed)
        val TertiaryFixedDim = Color.rgb(0x94d1d1)
        val OnTertiaryFixed = Color.rgb(0x002020)
        val OnTertiaryFixedVariant = Color.rgb(0x044f4f)

        // Errors
        val Error = Color.rgb(0xba1a1a)
        val OnError = Color.rgb(0xffffff)
        val ErrorContainer = Color.rgb(0xffdad6)
        val OnErrorContainer = Color.rgb(0x93000a)
    }

    object Images {
        object Common {
            private const val PATH = "$BASE/common"
            const val LOGO = "$PATH/logo.svg"
        }

        object Icons {
            private const val PATH = "$BASE/icons"

            const val LINKEDIN = "$PATH/ic_linkedin.svg"
            const val FACEBOOK = "$PATH/ic_facebook.svg"
            const val INSTAGRAM = "$PATH/ic_instagram.svg"
        }

        object LANDING {
            private const val PATH = "$BASE/landing"

            const val HEADER_IMG = "$PATH/product_overview_bg.png"

            object SOCIAL_PROOF {
                private const val PATH = "$BASE/landing/social_proof"

                const val HEALTH_CANADA = "$PATH/health_canada.png"
                const val FDA_APPROVED = "$PATH/fda_approved.png"
                const val CDSCO = "$PATH/cdsco_india.png"
                const val HSA = "$PATH/health_science_authority_singapore.svg"
            }

            object PROTOCOLS {
                private const val PATH = "$BASE/landing/protocols"

                const val ACTIVE_GRASP = "$PATH/active_grasp.png"
                const val FINGER_INDIVIDUATION = "$PATH/finger_individuation.png"
                const val PINCH_STRENGTH = "$PATH/pinch_strength.jpg"
                const val TASK_SIMULATION = "$PATH/task_simulation.jpg"
                const val FORCE_ROM = "$PATH/force_rom.png"
                const val BIO_FEEDBACK = "$PATH/bio_feedback.jpg"
                const val INTRINSIC_MUSCLE = "$PATH/intrinsic_muscle.jpg"
                const val GAMIFIED_ENGAGEMENT = "$PATH/gamified_engagement.jpg"
            }

            object WORKFLOW {
                private const val PATH = "$BASE/landing/workflow"

                const val WORKFLOW_1 = "$PATH/workflow_1.png"
                const val WORKFLOW_2 = "$PATH/workflow_2.jpg"
                const val WORKFLOW_3 = "$PATH/workflow_3.png"
            }
        }

        object Portal {
            private const val PATH = "$BASE/portal"
        }
    }

    object Breakpoints {
        val SM = Breakpoint.SM
        val MD = Breakpoint.MD
        val LG = Breakpoint.LG
        val XL = Breakpoint.XL
        val XXL = Breakpoint.XXL
    }
}